export function getStampImageUrl(path: string) {
  return `${window.location.origin}/stamps/${path}`;
}
